// extracted by mini-css-extract-plugin
export var truncate = "_r-0";